import DxResizable from "devextreme-react/resizable";
import React, { memo, useCallback } from "react";
function Resizable({ onResizeStart, onResizeEnd, ...other }) {
    const handleResizeStart = useCallback((e) => {
        document.body.classList.add("unselectable");
        onResizeStart && onResizeStart(e);
    }, [onResizeStart]);
    const handleResizeEnd = useCallback((e) => {
        document.body.classList.remove("unselectable");
        onResizeEnd && onResizeEnd(e);
    }, [onResizeEnd]);
    return React.createElement(DxResizable, { ...other, onResizeStart: handleResizeStart, onResizeEnd: handleResizeEnd });
}
export default memo(Resizable);
